import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';

i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'en'],
    defaultNS: 'common',
    ns: ['common', 'auth', 'pos', 'accounting', 'admin', 'settings'],
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    detection: {
      // I18N-COVERAGE-01 (stopgap): consult ONLY the stored explicit choice — NOT
      // the browser locale. With no stored key, detection yields nothing and
      // `fallbackLng: 'fr'` supplies the default, so an unset/new user on an
      // English-locale device loads in French (the correct default for the
      // entirely-Francophone client base) instead of a mixed EN/FR screen. An
      // explicit FR/EN pick still persists to `looma-language` and is honored
      // first; `useLanguageSync` still applies `user_metadata.language` on login.
      order: ['localStorage'], // was ['localStorage', 'navigator']
      lookupLocalStorage: 'looma-language',
      caches: ['localStorage'],
    },
    interpolation: {
      escapeValue: false,
    },
    react: {
      useSuspense: true,
    },
  });

export default i18n;
